<div class="cm-promo-grid" *ngIf="promotionInfos && promotionInfos.length > 0">
  <div class="promo-list">
    <div class="promo-item" *ngFor="let promotion of promotionInfos">
      <figure class="promo-item-media cm__ar-380x290">
        <img
          data-src="{{
            promotion.imageDetails?.src ? promotion.imageDetails?.src : '../../../../../assets/images/default-img.png'
          }}"
          alt="{{ promotion.imageDetails?.alt }}"
          data-object-fit="cover"
          width="580"
          height="443"
          class="initial loaded"
          data-was-processed="true"
          tabindex="0"
        />
      </figure>
      <a
        class="promo-item-title"
        target="_blank"
        href="{{ promotion.promosUrl }}"
        attr.aria-label="Learn more about {{ promotion.imageDetails?.alt }}"
      >
        <span class="cm__high-contrast-text">{{ promotion.title }}</span>
      </a>
    </div>
  </div>
</div>
